import { Routes } from '@angular/router';
import { HomeComponent } from './home-component/home-component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [MsalGuard] },
  {
    path: 'kassenzeichen',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./kassenzeichen/kassenzeichen-home/kassenzeichen-home').then(
        (m) => m.KassenzeichenHome,
      ),
  },
  {
    path: 'zaehler-antraege',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./zaehler-antraege/zaehler-antraege-home/zaehler-antraege-home').then(
        (m) => m.ZaehlerAntraegeHome,
      ),
  },
  {
    path: 'zaehler-antraege/:id',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./zaehler-antraege/zaehler-antraege-edit/zaehler-antraege-edit').then(
        (m) => m.ZaehlerAntraegeEdit,
      ),
  },
  {
    path: 'zaehler',
    canActivate: [MsalGuard],
    loadComponent: () => import('./zaehler/zaehler-home/zaehler-home').then((m) => m.ZaehlerHome),
  },
  {
    path: 'ablesungen',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./ablesungen/ablesungen-home/ablesungen-home').then((m) => m.AblesungenHome),
  },
];
